<div class="shimmer-wrapper">
  <div class="top-header">
    <div class="logo">
      <img [src]="logo$|async" alt="SYNLAB Logo" srcset="" [ngClass]="{'isDfpLogo': isUkDfp$|async}">
    </div>
    <div class="locale-picker">
      <app-shimmer-loading [loaderWidth]="'100%'" [loaderHeight]="'56px'"></app-shimmer-loading>
    </div>
    <div class="profile">
      <app-shimmer-loading [loaderWidth]="'100%'" [loaderHeight]="'56px'"></app-shimmer-loading>
    </div>
  </div>
  <div class="menu-link">
    <app-shimmer-loading [loaderWidth]="'100%'" [loaderHeight]="'56px'"></app-shimmer-loading>
  </div>
  <div class="content">
    <div class="sidebar">
      <app-shimmer-loading [loaderWidth]="'120px'" [loaderHeight]="'30px'"></app-shimmer-loading>
      <div class="spacer"></div>
      <app-shimmer-loading [loaderWidth]="'100%'" [loaderHeight]="'60px'"></app-shimmer-loading>
      <div class="spacer"></div>
      <div class="spacer"></div>

      <div class="spacer"></div>
      <div class="spacer"></div>
      <app-shimmer-loading [loaderWidth]="'50px'" [loaderHeight]="'50px'" [rounded]="true"></app-shimmer-loading>
      <div class="spacer"></div>
      <app-shimmer-loading [loaderWidth]="'100%'" [loaderHeight]="'60px'"></app-shimmer-loading>
      <div class="spacer"></div>
      <app-shimmer-loading [loaderWidth]="'100%'" [loaderHeight]="'30px'"></app-shimmer-loading>
    </div>
    <div class="result" >
      <app-shimmer-loading [loaderWidth]="'400px'" [loaderHeight]="'45px'"></app-shimmer-loading>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <div class="tab">
        <app-shimmer-loading [loaderWidth]="'150px'" [loaderHeight]="'45px'"></app-shimmer-loading>
        <app-shimmer-loading [loaderWidth]="'150px'" [loaderHeight]="'45px'"></app-shimmer-loading>
      </div>
      <div class="spacer" hidden></div>
      <div class="spacer" hidden></div>
      <app-shimmer-loading hidden [loaderWidth]="'80%'" [loaderHeight]="'140px'"></app-shimmer-loading>
      <div class="spacer"></div>
      <app-shimmer-loading hidden [loaderWidth]="'80%'" [loaderHeight]="'140px'"></app-shimmer-loading>
    </div>
  </div>
</div>
